import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { showToast } from 'shared/ui'
import { VoiceServicesApi } from 'entities/Compliance/api/voiceServicesApi'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SettingsPath } from 'pages/settings/route/settingsPath'
import { type CallingStepsStore } from './callingStepsStore'

export class StirShakenStore {
  constructor(private _callingStepsStore: CallingStepsStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  private _isTermsAndPrivacyChecked = false

  get isTermsAndPrivacyChecked() {
    return this._isTermsAndPrivacyChecked
  }

  get callingStepsStore() {
    return this._callingStepsStore
  }

  toggleIsTermsAndPrivacyChecked = (value: boolean) => {
    this._isTermsAndPrivacyChecked = value
  }

  submitStirShaken = async () => {
    if (this.callingStepsStore.complianceLayerStore.preventSubmitModal()) {
      return
    }

    try {
      this.callingStepsStore.stepsStore.setStepLoading(true)

      if (!this._entities.organizationStore.name) return

      const { data } = await VoiceServicesApi.addOrganizationShakenStir({
        name: this._entities.organizationStore.name,
      })

      showToast({
        type: 'info',
        title: 'STIR / SHAKEN submitted for review',
      })

      this._entities.complianceStore.complianceVoiceServicesStore.setShakenStir(data.data)

      uiStore.changeRoute({
        path: `/${SettingsPath.compliance.calling.root}`,
      })
    } catch (e) {
      logger.error(e)
    } finally {
      this.callingStepsStore.stepsStore.setStepLoading(false)
    }
  }
}
